export type ChartCollection = "all" | "saved" | "shared";

export type ChartsSearch = {
  q?: string;
  type?: string[];
  authority?: string[];
  definition?: string[];
  profile?: string[];
  cross?: string[];
  gate?: string[];
  channel?: string[];
  variable?: string[];
};

const SEARCH_KEYS = [
  "type",
  "authority",
  "definition",
  "profile",
  "cross",
  "gate",
  "channel",
  "variable",
] as const;

type ChartsSearchInput = Record<string, string | string[] | undefined>;

function normalizeValues(value: string | string[] | undefined) {
  const values = Array.isArray(value) ? value : [value];
  const normalized = values
    .flatMap((entry) => (typeof entry === "string" ? entry.split(",") : []))
    .map((entry) => entry.trim())
    .filter(Boolean);
  return [...new Set(normalized)];
}

export function validateChartsSearch(search: ChartsSearchInput): ChartsSearch {
  const result: ChartsSearch = {};
  const query = typeof search.q === "string" ? search.q.trim() : "";
  if (query) result.q = query;

  for (const key of SEARCH_KEYS) {
    const values = normalizeValues(search[key]);
    if (values.length > 0) result[key] = values;
  }

  return result;
}

export function chartCollectionPath(collection: ChartCollection) {
  return collection === "all" ? "/charts" : `/charts/${collection}`;
}
